/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';

const gatewayConfSelector = state => state.gateway.gatewayConf;

function stripComment(str = '') {
  const result = str
    .replace(/\/\*[^*]*\*\//g, '\n')
    .replace(/(?:^|\n|\r)\s*\/\/.*(?:\r|\n|$)/g, '\n');
  return result;
}

export const confSelector = createSelector(
  gatewayConfSelector,
  (gatewayConf) => {
    const { status, data } = gatewayConf;
    if (status === 'success') {
      return JSON.parse(stripComment(data.result));
    }
    return {};
  },
);




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/ConfView/selectors.js